import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  styled,
  Collapse,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import moment from "moment";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/ArrowIcon.svg";
import styles from "../../styles";
import {
  milestoneStatusStyleArray,
  paymentStatusStyleArray,
} from "../../config";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { formatAmountWithCurrency } from "../../../../utils/CurrencyUtils";
import { useTheme } from "@emotion/react";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

const StyledTableCellWithoutPadding = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  padding: "0 !important",
}));

const MobileView = ({ details }) => {
  const [expandedGroups, setExpandedGroups] = useState({});

  const toggleGroupExpansion = (groupId) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupId]: !prev[groupId],
    }));
  };

  return (
    <div
      style={{ padding: "2vh 0", backgroundColor: "#fff", minHeight: "100vh" }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
        {details?.payment_groups?.map((group, idx) => (
          <div
            key={group.group_id}
            style={{
              backgroundColor: "#fff",
              borderRadius: "none",
              padding: "16px 0",
              borderBottom: "1px solid #D7D8D9",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333",
                    marginBottom: "2vh",
                  }}
                >
                  {group.group_name}
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "8px",
                  }}
                >
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor:
                        milestoneStatusStyleArray.find(
                          (style) => style.status === group?.status
                        )?.backgroundColor || "#FFAD5C",
                    }}
                  />
                  <span style={{ fontSize: "12px", color: "#666" }}>
                    {getStatusDisplayText(group?.status)}
                  </span>
                </div>
              </div>
              {group.milestones.length > 0 && (
                <IconButton
                  size="small"
                  onClick={() => toggleGroupExpansion(group.group_id)}
                  style={{ marginLeft: "8px" }}
                >
                  {expandedGroups[group.group_id] ? (
                    <ExpandLessIcon fontSize="small" />
                  ) : (
                    <ExpandMoreIcon fontSize="small" />
                  )}
                </IconButton>
              )}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "12px",
              }}
            >
              <div>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "4px",
                  }}
                >
                  Due Date
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "500",
                  }}
                >
                  {moment(group.due_date).format("MMM DD, YYYY")}
                </p>
              </div>
              <div>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "4px",
                  }}
                >
                  Amount
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  {formatAmountWithCurrency(group.amount, 'small', {
                    containerStyle: {
                      fontSize: "14px",
                      color: "#333",
                      fontWeight: "500",
                    }
                  })}
                </div>
              </div>
            </div>

            {expandedGroups[group.group_id] && group.milestones.length > 0 && (
              <div
                style={{
                  background: "#f5f5f5",
                  padding: "1rem",
                  borderRadius: "12px",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333",
                    marginBottom: "8px",
                  }}
                >
                  Milestones
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  {group.milestones?.map((milestone) => (
                    <div
                      key={milestone.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 0",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#333",
                            fontWeight: "500",
                            marginBottom: "2px",
                          }}
                        >
                          {milestone.milestone_name}
                        </p>
                        <p style={{ fontSize: "12px", color: "#666" }}>
                          {milestone?.end_date &&
                            moment(milestone?.end_date).format("MMM DD, YYYY")}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        {formatAmountWithCurrency(milestone.amount, 'small', {
                          containerStyle: {
                            fontSize: "14px",
                            color: "#333",
                            fontWeight: "500",
                          }
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default function PaymentGroups({ details }) {
  const [expandedRows, setExpandedRows] = useState({});
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const mobileStyles = styles(isMobile);

  const toggleRowExpansion = (groupId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [groupId]: !prev[groupId],
    }));
  };

  if (isMobile) {
    return <MobileView details={details} />;
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        overflow: "none !important",
        boxShadow: "none",
        maxHeight: "87vh",
        marginTop: "2vh",
      }}
    >
      <Table
        sx={{
          "& thead": {
            "& th": {
              color: "#949DAA",
              fontWeight: "500",
            },
          },
          "& tbody": {
            "& tr:hover": {
              backgroundColor: "#f7f7f7",
            },
            "& tr": {
              borderBottom: "none",
            },
          },
        }}
      >
        <TableHead>
          <TableRow>
            <StyledTableCell>Payment Group</StyledTableCell>
            <StyledTableCell>Due Date</StyledTableCell>
            <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
              <strong
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                Amount (<SmallDhiramIcon />)
              </strong>
            </StyledTableCell>

            <StyledTableCell>Payment Group Status</StyledTableCell>
            <StyledTableCell>Action</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {details?.payment_groups?.map((group, idx) => (
            <React.Fragment key={group.group_id}>
              <TableRow>
                <StyledTableCell>{group.group_name}</StyledTableCell>
                <StyledTableCell>
                  {moment(group.due_date).format("MMM DD, YYYY")}
                </StyledTableCell>
                <StyledTableCell sx={{ textAlign: "right" }}>
                  {formattedAmountWithoutAed(group.amount)}
                </StyledTableCell>{" "}
                <StyledTableCell>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Box
                      sx={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        border: "3px solid rgb(229, 229, 229)",
                        backgroundColor:
                          milestoneStatusStyleArray.find(
                            (style) => style.status === group?.status
                          )?.backgroundColor || "#FFAD5C",
                      }}
                    />
                    <Box
                      sx={{
                        fontSize: "14px",
                        color: "#0D0D0E",
                      }}
                    >
                      {getStatusDisplayText(group?.status)}
                    </Box>
                  </Box>
                </StyledTableCell>
                <StyledTableCell>
                  {group.milestones.length > 0 && (
                    <IconButton
                      size="small"
                      onClick={() => toggleRowExpansion(group.group_id)}
                    >
                      {expandedRows[group.group_id] ? (
                        <ExpandLessIcon fontSize="small" />
                      ) : (
                        <ExpandMoreIcon fontSize="small" />
                      )}
                    </IconButton>
                  )}
                </StyledTableCell>
              </TableRow>
              {expandedRows[group.group_id] && group.milestones.length > 0 && (
                <TableRow>
                  <StyledTableCellWithoutPadding
                    colSpan={4}
                    sx={{
                      paddingBottom: 0,
                      paddingTop: 0,
                      borderBottom: "none",
                      paddingLeft: "1rem !important",
                    }}
                  >
                    <Collapse
                      in={expandedRows[group.group_id] || false}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        <ArrowIcon />
                        <Table
                          size="small"
                          sx={{ width: "100%", marginTop: "1.5vh" }}
                        >
                          <TableHead>
                            <TableRow>
                              <StyledTableCell>Milestone Name</StyledTableCell>
                              <StyledTableCell>End Date</StyledTableCell>
                              <StyledTableCell sx={{ textAlign: "right" }}>
                                <strong
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  Amount (<SmallDhiramIcon />)
                                </strong>
                              </StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {group.milestones?.map((milestone) => (
                              <TableRow key={milestone.id}>
                                <StyledTableCell>
                                  {milestone.milestone_name}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {milestone?.end_date &&
                                    moment(milestone?.end_date).format(
                                      "MMM DD, YYYY"
                                    )}
                                </StyledTableCell>
                                <StyledTableCell sx={{ textAlign: "right" }}>
                                  {formattedAmountWithoutAed(milestone.amount)}
                                </StyledTableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </StyledTableCellWithoutPadding>
                </TableRow>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
